import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './Preview.css';
import { ResponsiveImage } from '../../../ResponsiveImage';

export interface IPreviewProps {
  image: string;
  aspectRatio?: number;
  fullHeight?: boolean;
}

export const Preview: React.FC<IPreviewProps> = ({ image, aspectRatio, fullHeight }) => {
  return (
    <div className={styles['container']}>
      {fullHeight ? (
        <div className={styles['full-height-image']}>
          <Image width="100%" height="100%" objectFit="cover" src={image} />
        </div>
      ) : (
        <ResponsiveImage src={image} aspectRatio={aspectRatio} />
      )}
    </div>
  );
};
